import React from 'react';
import { HeadphonesIcon, RocketIcon, ShieldCheckIcon } from 'lucide-react';
import { CallCta, StartCta } from './CtaButton';
const trustSignals = [{
  icon: RocketIcon,
  label: '10+ businesses launched'
}, {
  icon: HeadphonesIcon,
  label: '24/7 AI support'
}, {
  icon: ShieldCheckIcon,
  label: '3-month minimum, no surprises'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-black text-brand-white" data-id="element-43" data-mp="4jvw9cbadaws">
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 -top-40 h-[34rem] w-[34rem] rounded-full bg-[radial-gradient(circle,rgba(188,33,39,0.55)_0%,rgba(188,33,39,0.16)_45%,rgba(188,33,39,0)_72%)] blur-[2px]" data-id="element-44" data-mp="127eereur1rdz" />
      <div aria-hidden="true" className="pointer-events-none absolute right-[-10rem] top-24 h-[26rem] w-[26rem] rounded-full bg-[radial-gradient(circle,rgba(188,33,39,0.32)_0%,rgba(188,33,39,0)_70%)]" data-id="element-45" data-mp="nczvdd79wfys" />
      <div className="relative mx-auto max-w-6xl px-5 pb-16 pt-12 sm:px-8 sm:pb-20 sm:pt-16 lg:pb-28 lg:pt-20" data-id="element-46" data-mp="380vznzu8sxe7">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:items-center lg:gap-16" data-id="element-47" data-mp="3j9aldp7jncay">
          <div data-id="element-48" data-mp="3o59bpicfn4e0">
            <p className="inline-block border-l-4 border-brand-red pl-3 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-white sm:text-xs" data-id="element-49" data-mp="39alaige2es47">
              72-Hour Launch — Limited Time
            </p>

            <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.03] tracking-tight sm:text-5xl lg:text-[4.25rem]" data-id="element-50" data-mp="30hho3ilfz4xf">
              Your Business, Online in{' '}
              <span className="text-brand-red" data-id="element-51" data-mp="2qjv8etwbj9ce">72 Hours</span>
              <br className="hidden sm:block" data-id="element-52" data-mp="2qleqmq1jbugt" /> — Not 3 Months
            </h1>

            <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-light sm:text-lg" data-id="element-53" data-mp="2vjzpal152635">
              Most agencies take months to build your website. We build the shell of yours in 72
              hours — then you just message changes through Slack and our AI (MISTR) makes them.{' '}
              <span className="font-semibold text-brand-white" data-id="element-54" data-mp="s3349bcaykwh">
                No developer, no waiting, no hassle.
              </span>
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-55" data-mp="n9i71lij9uyc">
              <StartCta size="lg" data-id="element-56" data-mp="i9vqp37erylb" />
              <CallCta size="lg" variant="onDark" data-id="element-57" data-mp="ddwwgyzefmcz" />
            </div>

            <ul className="mt-9 flex flex-col gap-3 border-t border-brand-white/15 pt-7 sm:flex-row sm:flex-wrap sm:gap-x-8 sm:gap-y-3" data-id="element-58" data-mp="1b0vwnjpavcfm">
              {trustSignals.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-59" data-mp="112pwp7n20gde">
                  <Icon className="h-4 w-4 flex-none text-brand-red" aria-hidden="true" data-id="element-60" data-mp="x14ohzlgsq9j" />
                  <span className="font-medium" data-id="element-61" data-mp="x3h2k1o3qghb">{label}</span>
                </li>)}
            </ul>
          </div>

          <div className="lg:pl-6" data-id="element-62" data-mp="3hqu2ybi9aa1p">
            <div className="border-l-2 border-brand-red pl-6" data-id="element-63" data-mp="3hpsdv34enn0z">
              <p className="font-display text-7xl font-extrabold leading-none text-brand-white sm:text-8xl" data-id="element-64" data-mp="1x9ukg9uwtbmw">
                72
              </p>
              <p className="mt-2 font-display text-xl font-bold uppercase tracking-[0.2em] text-brand-red" data-id="element-65" data-mp="21b64lzv0l4np">
                Hours
              </p>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-brand-light" data-id="element-66" data-mp="2b196yqo0zuyp">
                From kickoff call to a live site shell you can look at, click through, and start
                sending changes for.
              </p>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-7 border-t border-brand-white/15 pt-8" data-id="element-67" data-mp="2kx2ic6q0diew">
              <div data-id="element-68" data-mp="2oye6s8x5bxli">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-69" data-mp="2tzle66vdmurn">
                  Changes
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-70" data-mp="unixt5i1ugi7">
                  Message them in Slack
                </dd>
              </div>
              <div data-id="element-71" data-mp="4be0pqxbgttw">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-72" data-mp="4al077oyb0k7">
                  Who does them
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-73" data-mp="3vjrsk9bazrr0">MISTR, our AI</dd>
              </div>
              <div data-id="element-74" data-mp="e77ipptt1fj2">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-75" data-mp="9aqms9gd5wvf">
                  Phones
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-76" data-mp="3hqse8an9c3l1">
                  AI attendant, 24/7
                </dd>
              </div>
              <div data-id="element-77" data-mp="3rftve45jgr0l">
                <dt className="text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-78" data-mp="3rgc1dsi06jlp">
                  Leads
                </dt>
                <dd className="mt-1.5 text-sm font-semibold text-brand-white" data-id="element-79" data-mp="3mnafh0jdpjsm">
                  Your own CRM account
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>;
}